<div class="table-container">
    <table class="table">
        <thead class="sticky-header">
            <tr class="table-header">
                <th class="sticky-header text-center bg">Site Name</th>
                <th class="sticky-header text-center bg">Skip India TSS</th>
                <th class="sticky-header text-center bg">Outage Ticket Duration (Hrs)</th>
                <th class="sticky-header text-center bg">Last Modified By</th>
                <th class="sticky-header text-center bg">Last Modified Date (UTC)</th>
            </tr>
        </thead>
        <tbody style="margin-top: 10px;">
          <ng-container *ngIf="accountHistory && accountHistory.length > 0">
            <tr *ngFor="let history of accountHistory">
                <td class="text-center">{{history.siteName || 'N/A'}}</td>
                <td class="text-center">{{history.indiaTssSkip === true ? 'Yes' : (history.indiaTssSkip === false ? 'No' : '') || 'N/A'}}</td>
                <td class="text-center">{{history.ticketCreationDuration || 'N/A'}}</td>
                <td class="text-center">{{history.lastModifiedBy || 'N/A'}}</td>
                <td class="text-center">
                    <span class="date-margin">{{ formatdate(history.lastModifiedDate) || 'N/A'}}</span>
                </td>
            </tr>
          </ng-container>                
        </tbody>
    </table>
    <div *ngIf="accountHistory?.length == 0" class="text-center no-data">NO DATA AVAILABLE</div>
    </div>
    
    <div class="button-container">
        <button mat-button mat-raised-button color="warn" class="back" (click)="closeAndNavigate()">BACK</button>
    </div>
